import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

/* CSS imports — order matters: tokens first so every other file
   can reference --theo-a, etc. The rest of the order is
   roughly top-of-page → bottom-of-page for predictability. */
import './styles/tokens.css';
import './styles/base.css';
import './styles/nav.css';
import './styles/hero.css';
import './styles/cta-band.css';
import './styles/product-page.css';
import './styles/footer.css';

import App from './App.jsx';

const root = createRoot(document.getElementById('root'));
root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
